/**
 * How a project's cover image is framed.
 *
 * Staff frame the cover in the Project cover image editor on the project overview, and what gets
 * stored is metadata rather than a cropped file: a focal point as whole percentages on each axis,
 * plus a 1-4x zoom. The original media-library asset is never altered, so the crop can be redone at
 * any time — which means the portal has to reproduce the framing itself.
 *
 * With `object-fit: cover` already on the element, `object-position` picks which part of the image
 * survives the crop, and the scale transform (anchored to that same point) applies the zoom. Keep
 * this in step with api-portal_public.php's project_cover() and the staff-side editor's geometry.
 */
export function portalCoverStyle(project: any): { [key: string]: string } {
	const x = coverNumber(project?.image_position_x, 50, 0, 100);
	const y = coverNumber(project?.image_position_y, 50, 0, 100);
	const zoom = coverNumber(project?.image_zoom, 1, 1, 4);
	const position = x + '% ' + y + '%';

	return {
		'object-position': position,
		'transform-origin': position,
		transform: 'scale(' + zoom + ')'
	};
}

function coverNumber(value: any, fallback: number, min: number, max: number): number {
	const n = +value;
	if (!isFinite(n)) return fallback;
	return Math.max(min, Math.min(max, n));
}
